/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import React, { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AgenciasDropdown, Loader } from "..";
import { getAniosFacturaDisponibles } from "../../constants/anios";
import { ROLES } from "../../constants/roles";
import { useAuthContext } from "../../context/auth";
import {
  getContratos,
  log,
  updateContrato,
  updateOportunidad,
  updateOportunidadBTL,
} from "../../utils";
import { getCountComprasSinClasificar } from "../../utils/badges";
import { FECHA_CORTE } from "../../utils/estadoCuenta";
import { getImporteFacturable, TOLERANCIA_MONTO_FACTURABLE } from "../../utils/getImporteFacturable";
import { getLocale } from "../../utils/getLocale";
import { resolverVolumenInter } from "../../utils/resolverVolumenInter";
import { client } from "../../utils/supabase";
import { useExchangeRates } from "../../utils/useExchangeRates";
import { useTableSort } from "../../utils/useTableSort";
import { Header } from "../Header";
import PlanCuotasModal from "../PlanCuotasModal";
import ComprasTab, {
  OPCIONES_CLASIFICACION,
  OPCIONES_PAGO,
  OPCIONES_TIPO,
  OPCIONES_ESTADO_SII,
  CUENTAS_AGRUPADAS,
} from "./ComprasTab";
import { derivarEscalaresVentaFila } from "./derivarEscalaresVentaFila";
import { useVFDataLoading } from "./hooks/useVFDataLoading";
import { useVFEditModal } from "./hooks/useVFEditModal";
import { useVFFiltering } from "./hooks/useVFFiltering";
import { useVFFormatting } from "./hooks/useVFFormatting";
import SeleccionarDTEModal from "./SeleccionarDTEModal";
import styles from "./VentasFacturas.module.scss";

export const VentasFacturas = () => {
  const [tabActivo, setTabActivo] = useState("ventas");
  const [siiModalOportunidad, setSiiModalOportunidad] = useState(null);
  const [cobroPickerOp, setCobroPickerOp] = useState(null);
  const [comprasMeses, setComprasMeses] = useState([]);
  // Fase 3b: los filtros espejan los DOS EJES de la tabla (clasificación / pago) más tipo de
  // documento. Reemplazan al par cuenta-ER + estado-contable, que mezclaba ambos ejes.
  const [comprasClasificacion, setComprasClasificacion] = useState("");
  const [comprasTipo, setComprasTipo] = useState("");
  const [comprasPago, setComprasPago] = useState("");
  const [comprasEstadoSii, setComprasEstadoSii] = useState("");
  const [comprasBusqueda, setComprasBusqueda] = useState("");
  const { pais, rol, id: userId } = useAuthContext();
  const navigate = useNavigate();
  const esChile = pais === "Chile";
  const puedeEditar = (oportunidad) =>
    !esChile &&
    ([ROLES.GERENCIA, ROLES.ADMINISTRATIVO].includes(rol) ||
      (rol === ROLES.COMERCIAL && oportunidad?.ejecutivo === parseInt(userId, 10)));
  const { getDolarValue, getUFValue, dolarFallback, loaded: ratesLoaded } = useExchangeRates(pais);
  const {
    moneda, decimales, getRateForOportunidad, getDolarRateForDate,
    mesEnLetras, resolverNombreIntermediario, fechaLocal, esCuotaEditable, getEstadoCobro, fecha,
  } = useVFFormatting(pais, getDolarValue, dolarFallback);
  const {
    todasOportunidades, setTodasOportunidades, intermediarios, clientes,
    usuarios, ejecutivosUnicos, siiMap, factoringMap, pctMap, recargarSiiMap, isDataLoaded,
  } = useVFDataLoading(pais, getUFValue, ratesLoaded);
  // Años del filtro derivados de los datos ya cargados (no literal).
  const possibleYears = useMemo(() => getAniosFacturaDisponibles(todasOportunidades), [todasOportunidades]);
  const {
    filtroNumeroFactura, setFiltroNumeroFactura, filtroCliente, setFiltroCliente,
    filtroCobrada, setFiltroCobrada, filtroAnos,
    filtroMeses, filtroTipo, setFiltroTipo,
    filtroModalidad, setFiltroModalidad, filtroIntermediario, setFiltroIntermediario,
    filtroFacturado, setFiltroFacturado, filtroMoneda, setFiltroMoneda,
    filtroEjecutivo, setFiltroEjecutivo,
    oportunidadesFiltradas, porcentajesVertical, numerosFacturaUnicos, clientesUnicos,
    handleMesChange, handleAnoChange, totales,
  } = useVFFiltering({
    todasOportunidades, intermediarios, clientes, usuarios, pais,
    resolverNombreIntermediario, getRateForOportunidad, getDolarRateForDate, siiMap, pctMap,
  });
  const {
    showModal, oportunidadEditada, formData, loading, error, warnSinEdificios,
    registrarComoCredito, setRegistrarComoCredito, otrasConMismaFactura,
    handleOpenModal, handleCloseModal, handleInputChange, handleSaveChanges, handleClearFactura,
    facturaSIIVinculada,
  } = useVFEditModal({ todasOportunidades, setTodasOportunidades, pais, getUFValue, userId });
  const [planCuotasModal, setPlanCuotasModal] = useState(null);
  const [sincronizandoSII, setSincronizandoSII] = useState(false);
  const [comprasSinClasificarCount, setComprasSinClasificarCount] = useState(0);
  // Nonce que se incrementa tras un sync SII exitoso para re-disparar la carga de ComprasTab
  // sin remontarlo (ver reloadNonce en ComprasTab). recargarSiiMap refresca Ventas; esto, Compras.
  const [comprasSyncNonce, setComprasSyncNonce] = useState(0);

  useEffect(() => {
    if (!pais || pais === "Region") return;
    (async () => {
      try {
        setComprasSinClasificarCount(await getCountComprasSinClasificar(pais));
      } catch {
        // silently ignore
      }
    })();
  }, [pais]);

  const handleSyncSII = async () => {
    setSincronizandoSII(true);
    try {
      const hoy = new Date();
      const desde = `${hoy.getFullYear()}-01-01`;
      const hasta = hoy.toISOString().split("T")[0];
      const url = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/sii-sync?desde=${desde}&hasta=${hasta}&pais=${pais}`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      // El sync ya no miente: si no pudo insertar, viene success:false + errores[]. Antes solo se
      // miraba data.error y un upsert fallado (tragado) devolvía success:true → "correctamente".
      if (data.error || data.success === false) {
        const detalle = data.error || data.errores?.[0]?.message || "no se pudo insertar";
        throw new Error(detalle);
      }
      const nuevas = data.recibidas?.nuevas ?? 0;
      const totalClay = data.recibidas?.total_clay ?? 0;
      toast.success(`${esChile ? "SII" : "SUNAT"} sincronizado: ${nuevas} compra(s) nueva(s) de ${totalClay}`);
      await recargarSiiMap();
      setComprasSyncNonce((n) => n + 1);
    } catch (e) {
      toast.error(`Error al sincronizar ${esChile ? "SII" : "SUNAT"}: ${e?.message || e}`);
    } finally {
      setSincronizandoSII(false);
    }
  };
  // Moneda y decimales de visualización según modo
  const displayMoneda = filtroMoneda === "USD" ? "US$" : moneda(pais);
  const displayDecimales = filtroMoneda === "USD" ? 0 : decimales(pais);

  // Obtener datos de vinculación SII de una oportunidad (null si no vinculada)
  const getVinculacionSII = (oportunidad) => {
    let refKey = null;
    if (oportunidad.negocio_id) {
      refKey = `negocios_carteleria:${oportunidad.negocio_id}:${oportunidad.sii_ref_index ?? ""}`;
    } else if (oportunidad.type === "pauta") {
      refKey = `sales:${oportunidad.id}:`;
    } else if (oportunidad.type === "BTL") {
      refKey = `sales_btl:${oportunidad.id}:`;
    } else if (oportunidad.type === "contrato") {
      refKey = `sales_contratos:${oportunidad.contrato_id}:${oportunidad.mes_index ?? ""}`;
    }

    if (refKey && siiMap._byRef?.[refKey]) return siiMap._byRef[refKey];

    if (oportunidad.facturanumero) {
      const entry = siiMap[String(oportunidad.facturanumero)];
      if (entry) return { facturaId: entry.facturaId, folio: Number(oportunidad.facturanumero) };
    }

    return null;
  };

  const tieneVinculacionSII = (oportunidad) => !!getVinculacionSII(oportunidad);

  // Callback post-vinculación del modal DTE. Refresca siiMap (fuente del ✓) y, para cartelería,
  // parchea la fila por ID (10.7/10.234) con el sii_ref_index EFECTIVO que la vinculación resolvió/
  // creó en meses_facturacion. Sin este patch la refKey de lectura (getVinculacionSII) sigue armada
  // con el índice viejo (null) y no matchea la nueva entrada de _byRef hasta refrescar la página.
  // Pauta/contrato no lo necesitan: sus refKeys usan campos estables (id / mes_index) que no mutan.
  const handleVinculada = async (patch) => {
    await recargarSiiMap();
    if (!patch?.esCarteleria) return;
    if (patch.siiRefIndex == null) {
      // 10.177: una vinculación de cartelería SIEMPRE resuelve un índice; un null acá es anómalo.
      log.error("handleVinculada", `Vinculación de cartelería sin sii_ref_index (op ${patch.opId})`);
      return;
    }
    const existe = todasOportunidades.some((op) => op.id === patch.opId && op.type === patch.opType);
    if (!existe) {
      // 10.177: si no ubicamos la fila, avisamos en vez de tragarnos el patch en silencio.
      log.error("handleVinculada", `No se ubicó el op ${patch.opId} (${patch.opType}) para patchear sii_ref_index`);
      return;
    }
    setTodasOportunidades((prev) =>
      prev.map((op) =>
        op.id === patch.opId && op.type === patch.opType ? { ...op, sii_ref_index: patch.siiRefIndex } : op
      )
    );
  };

  // Folio a mostrar: la vinculación SII por ID es la fuente primaria; el texto
  // sales.facturanumero queda como fallback para las ventas históricas sin vinculación.
  const getDisplayFolio = (oportunidad, vincSII = getVinculacionSII(oportunidad)) =>
    vincSII ? String(vincSII.folio) : oportunidad.facturanumero || null;

  // ─── Filas del tab "ventas" enriquecidas con los escalares derivados ───
  // Fuente única de los montos MOSTRADOS (VENTA/COMISIÓN/NETO) y de los escalares
  // ordenables que consumirá el sort en Fase 3. Map 1:1 → preserva el orden natural
  // de useVFFiltering. vincSII/cobrada se resuelven acá para alimentar el helper
  // (fecha_emision SII + flag cobrada) sin duplicar la lógica. Debe quedar ANTES del
  // early return de !isDataLoaded (rules-of-hooks).
  const filasVentas = useMemo(
    () =>
      oportunidadesFiltradas.map((op) => {
        const vincSII = getVinculacionSII(op);
        const cobrada = getEstadoCobro(op.facturafecha, op.facturafechacobro, op.plazocobro, !!vincSII).cobrada;
        const calc = derivarEscalaresVentaFila(op, {
          clientes,
          intermediarios,
          pais,
          pctMap,
          filtroMoneda,
          getRateForOportunidad,
          getDolarRateForDate,
          fechaLocal,
          fechaEmisionSII: vincSII?.fechaEmision || null,
          tieneVincSII: !!vincSII,
          cobrada,
        });
        return { op, calc };
      }),
    // getVinculacionSII/getEstadoCobro/fechaLocal son funciones puras de datos ya
    // listados (siiMap; hoy interno) — se omiten a propósito para no romper la
    // memoización (se recrean en cada render). Las tasas entran por callbacks estables.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [oportunidadesFiltradas, clientes, intermediarios, pais, pctMap, filtroMoneda, siiMap, getRateForOportunidad, getDolarRateForDate]
  );

  // ─── Ordenamiento por click en el header (Fase 3) ───
  // Los accessors leen los escalares YA materializados en Fase 2 (item.calc.*) o
  // los campos ya resueltos de la fila (item.op.*); nunca recalculan montos. Los
  // *Ordenable ya vienen en moneda local (regla 10.185). Nº FACTURA resuelve el
  // folio por getDisplayFolio (SII por ID → fallback facturanumero), null si no hay.
  const columnDefsVentas = {
    ejecutivo: { accessor: (item) => item.op.ejecutivoNombre, type: "text", nulls: "last" },
    folio: { accessor: (item) => getDisplayFolio(item.op), type: "text-numeric", nulls: "last" },
    fechaFactura: { accessor: (item) => item.calc.fechaFacturaTs, type: "date", nulls: "last" },
    cliente: { accessor: (item) => item.op.cliente, type: "text", nulls: "last" },
    intermediario: { accessor: (item) => item.op.intermediario, type: "text", nulls: "last" },
    venta: { accessor: (item) => item.calc.ventaOrdenable, type: "number", nulls: "last" },
    comisionPct: { accessor: (item) => item.calc.comisionPctOrdenable, type: "number", nulls: "last" },
    comisionMonto: { accessor: (item) => item.calc.comisionMontoOrdenable, type: "number", nulls: "last" },
    neto: { accessor: (item) => item.calc.netoOrdenable, type: "number", nulls: "last" },
    cobro: { accessor: (item) => item.calc.cobroOrdenable, type: "date", nulls: "last" },
  };
  const { sortConfig, handleSort, sortIndicator, sortRows } = useTableSort(columnDefsVentas);
  // dir === null (3er click) → sortRows devuelve el array intacto (orden natural
  // de useVFFiltering). El estado vive acá → el orden persiste al cambiar filtros.
  const filasVentasOrdenadas = sortRows(filasVentas);

  const renderColumnaFactoring = (op) => {
    const vinc = getVinculacionSII(op);
    if (!vinc?.facturaId) return <span style={{ color: "#ccc" }}>—</span>;

    const info = factoringMap?.get(vinc.facturaId);
    if (!info) return <span style={{ color: "#ccc" }}>—</span>;

    const esFactoring = info.tipoProveedor === "factoring";
    const colorActiva = esFactoring ? "#922b21" : "#1a5276";
    const color = info.estadoFactoring === "liquidada" ? "#27ae60" : colorActiva;
    const badgeLabel = esFactoring ? "F" : "P";

    const fechaFmt =
      esFactoring && info.fechaAdelantoFactoring
        ? (() => {
            const [, m, d] = info.fechaAdelantoFactoring.split("-");
            return `${d}/${m}`;
          })()
        : null;

    return (
      <div
        onClick={(e) => {
          e.stopPropagation();
          navigate("/admin/factoring");
        }}
        title={`${info.proveedorNombre} · ${info.estadoFactoring}`}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 4,
          whiteSpace: "nowrap",
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 15,
            height: 15,
            borderRadius: "50%",
            background: color,
            color: "#fff",
            fontSize: "0.6rem",
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          {badgeLabel}
        </span>
        {fechaFmt && <span style={{ color, fontWeight: 600, fontSize: "0.78rem" }}>{fechaFmt}</span>}
        <span style={{ color, fontSize: "0.68rem", opacity: 0.85 }}>{info.proveedorNombre}</span>
      </div>
    );
  };

  // ─── Guardar plazocobro inline ───
  const guardarPlazoCobro = async (oportunidad, fechaDate) => {
    const fechaStr = fechaDate ? fechaDate.toISOString().split("T")[0] : null;
    try {
      const vincSII = getVinculacionSII(oportunidad);
      if (vincSII?.facturaId) {
        await client
          .from("facturas_sii_emitidas")
          .update({ plazocobro: fechaStr })
          .eq("id", vincSII.facturaId);
        setTodasOportunidades((prev) =>
          prev.map((op) =>
            op.id === oportunidad.id && op.type === oportunidad.type
              ? { ...op, plazocobro: fechaStr }
              : op
          )
        );
        toast.success("Fecha de cobro actualizada");
        setCobroPickerOp(null);
        return;
      }
      if (oportunidad.type === "contrato") {
        const contratosRaw = await getContratos({ pais });
        const contrato = contratosRaw.find((c) => c.id === oportunidad.contrato_id);
        if (!contrato) throw new Error("Contrato no encontrado");
        const updatedMeses = [...(contrato.meses || [])];
        updatedMeses[oportunidad.mes_index] = {
          ...updatedMeses[oportunidad.mes_index],
          plazocobro: fechaStr,
        };
        await updateContrato({ id: contrato.id, contrato: { meses: updatedMeses } });
      } else if (oportunidad.type === "HW-CAPEX") {
        const { data: negocio } = await client
          .from("negocios_carteleria")
          .select("detalle_pagos_hardware")
          .eq("id", oportunidad.negocio_id)
          .single();
        const detalle =
          typeof negocio.detalle_pagos_hardware === "string"
            ? JSON.parse(negocio.detalle_pagos_hardware || "[]")
            : negocio.detalle_pagos_hardware || [];
        detalle[oportunidad.entry_index] = { ...detalle[oportunidad.entry_index], plazocobro: fechaStr };
        await client
          .from("negocios_carteleria")
          .update({ detalle_pagos_hardware: detalle })
          .eq("id", oportunidad.negocio_id);
      } else if (oportunidad.type === "HW-OPEX" || oportunidad.type === "Gestión") {
        const tipoFact = oportunidad.type === "HW-OPEX" ? "opex" : "gestion";
        const { data: negocio } = await client
          .from("negocios_carteleria")
          .select("meses_facturacion")
          .eq("id", oportunidad.negocio_id)
          .single();
        const mesesFact = negocio.meses_facturacion
          ? typeof negocio.meses_facturacion === "string"
            ? JSON.parse(negocio.meses_facturacion)
            : negocio.meses_facturacion
          : [];
        const idx = mesesFact.findIndex(
          (mf) => mf.mes === oportunidad.mes && mf.ano === oportunidad.ano && mf.tipo === tipoFact
        );
        if (idx >= 0) {
          mesesFact[idx] = { ...mesesFact[idx], plazocobro: fechaStr };
        } else {
          mesesFact.push({ mes: oportunidad.mes, ano: oportunidad.ano, tipo: tipoFact, plazocobro: fechaStr });
        }
        await client
          .from("negocios_carteleria")
          .update({ meses_facturacion: mesesFact })
          .eq("id", oportunidad.negocio_id);
      } else if (oportunidad.type === "BTL") {
        await updateOportunidadBTL({ id: oportunidad.id, oportunidad: { plazocobro: fechaStr } });
      } else {
        await updateOportunidad({ id: oportunidad.id, oportunidad: { plazocobro: fechaStr } });
      }
      // Actualizar estado local
      setTodasOportunidades((prev) =>
        prev.map((op) => (op.id === oportunidad.id && op.type === oportunidad.type ? { ...op, plazocobro: fechaStr } : op))
      );
      toast.success("Fecha de cobro actualizada");
    } catch (err) {
      console.error("Error guardando plazocobro:", err);
      toast.error("Error al guardar fecha de cobro");
    }
    setCobroPickerOp(null);
  };

  if (!ratesLoaded || !isDataLoaded) return <Loader />;

  const renderMesOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => (
      <div key={index} className="form-check-facturas" style={{ marginBottom: "5px" }}>
        <input
          className={styles.checkboxInput} type="checkbox"
          id={`mes${index}`}
          value={index < 9 ? `0${index + 1}` : `${index + 1}`}
          checked={filtroMeses.includes(index < 9 ? `0${index + 1}` : `${index + 1}`)}
          onChange={(e) => handleMesChange(e.target.value)}
        />
        <label
          className={styles.checkboxLabel}
          htmlFor={`mes${index}`}
        >
          {mes}
        </label>
      </div>
    ));

  const renderAnoOptions = () =>
    possibleYears.map((year, index) => (
      <div key={index} className="form-check-facturas" style={{ marginBottom: "5px" }}>
        <input
          className={styles.checkboxInput} type="checkbox"
          id={`ano${index}`}
          value={year}
          checked={filtroAnos.includes(year)}
          onChange={(e) => handleAnoChange(e.target.value)}
        />
        <label
          className={styles.checkboxLabel}
          htmlFor={`ano${index}`}
        >
          {year}
        </label>
      </div>
    ));

  const renderFilters = () => (
    <div className={styles.filtersContainer}>
      <div className={styles.filterRow}>
        <select
          className={`form-select ${filtroNumeroFactura ? styles.activeFilter : ""}`}
          value={filtroNumeroFactura}
          onChange={(e) => setFiltroNumeroFactura(e.target.value)}
        >
          <option value="">Nº Factura</option>
          {numerosFacturaUnicos.map((numero) => (
            <option key={numero} value={numero}>{numero}</option>
          ))}
        </select>
        <select
          className={`form-select ${filtroEjecutivo ? styles.activeFilter : ""}`}
          value={filtroEjecutivo}
          onChange={(e) => setFiltroEjecutivo(e.target.value)}
        >
          <option value="">Ejecutivo</option>
          {ejecutivosUnicos.map((ejecutivo) => (
            <option key={ejecutivo.id} value={ejecutivo.id}>
              {ejecutivo.nombre}
            </option>
          ))}
        </select>
        <select
          className={`form-select ${filtroFacturado ? styles.activeFilter : ""}`}
          value={filtroFacturado}
          onChange={(e) => setFiltroFacturado(e.target.value)}
        >
          <option value="">Todo</option>
          <option value="Facturado">Facturado</option>
          <option value="Sin facturar">Sin facturar</option>
        </select>
        <select
          className={`form-select ${filtroCliente ? styles.activeFilter : ""}`}
          value={filtroCliente}
          onChange={(e) => setFiltroCliente(e.target.value)}
        >
          <option value="">Cliente</option>
          {clientesUnicos.map((cliente) => (
            <option key={cliente} value={cliente}>{cliente}</option>
          ))}
        </select>
        <Dropdown>
          <Dropdown.Toggle
            variant="white"
            id="dropdown-mes"
            className={`${styles.dropdownToggle} ${filtroMeses.length > 0 ? styles.activeFilter : ""}`}
          >
            {/* Resumen compacto para no desbordar el ancho del control: 0 → "Mes"; 1-3 por nombre;
                >3 → "N meses"; los 12 → "Todos". Solo cambia el label mostrado, no el filtro. */}
            {filtroMeses.length === 0
              ? "Mes"
              : filtroMeses.length === 12
                ? "Todos"
                : filtroMeses.length <= 3
                  ? filtroMeses.map((mes) => mesEnLetras(mes)).join(", ")
                  : `${filtroMeses.length} meses`}
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ maxHeight: "370px", overflowY: "auto" }}>
            {renderMesOptions()}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className={styles.filterRow}>
        <AgenciasDropdown
          value={filtroIntermediario}
          onChange={(e) => setFiltroIntermediario(e.target.value)}
          intermediarios={intermediarios}
          placeholder="Intermediario"
          className={`form-select ${filtroIntermediario ? styles.activeFilter : ""}`}
        />
        <select
          className={`form-select ${styles.activeFilter}`}
          value={filtroMoneda}
          onChange={(e) => setFiltroMoneda(e.target.value)}
        >
          <option value="LOCAL">{pais === "Chile" ? "CLP" : "PEN"}</option>
          <option value="USD">US$</option>
        </select>
        <Dropdown>
          <Dropdown.Toggle
            variant="white"
            id="dropdown-ano"
            className={`${styles.dropdownToggle} ${filtroAnos.length > 0 ? styles.activeFilter : ""}`}
          >
            {filtroAnos.length > 0 ? filtroAnos.join(", ") : "Año"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {renderAnoOptions()}
          </Dropdown.Menu>
        </Dropdown>
        <select
          className={`form-select ${filtroCobrada ? styles.activeFilter : ""}`}
          value={filtroCobrada}
          onChange={(e) => setFiltroCobrada(e.target.value)}
        >
          <option value="">Cobrada</option>
          <option value="Sí">Sí</option>
          <option value="No">No</option>
        </select>
        <select
          className={`form-select ${filtroModalidad ? styles.activeFilter : ""}`}
          value={filtroModalidad}
          onChange={(e) => setFiltroModalidad(e.target.value)}
          disabled={filtroTipo !== "hardware"}
          style={{ opacity: filtroTipo !== "hardware" ? 0.4 : 1 }}
        >
          <option value="">Modalidad</option>
          <option value="CAPEX">CAPEX</option>
          <option value="OPEX">OPEX</option>
        </select>
      </div>
    </div>
  );

  const handleComprasMesChange = (periodo) =>
    setComprasMeses((prev) => (prev.includes(periodo) ? prev.filter((p) => p !== periodo) : [...prev, periodo]));

  const renderFiltrosCompras = () => {
    // Solo meses desde el corte contable (FECHA_CORTE) hasta el mes actual. Las facturas
    // históricas pre-corte (carga Nubox 2025) quedan fuera de la vista de Compras.
    const MIN_PERIODO = FECHA_CORTE.substring(0, 7); // "2026-01"
    const MESES_COMPRAS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    const periodos = [];
    const now = new Date();
    for (let i = 0; i < 24; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const val = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
      if (val < MIN_PERIODO) break;
      periodos.push(val);
    }
    // Solo el nombre del mes (sin año): el dropdown lista un único año (corte → mes actual),
    // así que no hay ambigüedad. El value interno del checkbox sigue siendo YYYY-MM.
    const getPeriodoLabel = (p) => MESES_COMPRAS[parseInt(p.split("-")[1], 10) - 1];
    const filterStyle = {
      height: 30,
      fontSize: "0.75rem",
      padding: "2px 8px",
      border: "1px solid #ced4da",
      borderRadius: 4,
      // Compactado: con 6 filtros (incl. Estado SII) el ancho previo (165) desbordaba la barra
      // y cortaba el buscador + botón "Sincronizar SII". Ver comprasFiltersRow.
      width: 130,
    };
    return (
      <div className={styles.comprasFiltersRow}>
        <Dropdown>
          <Dropdown.Toggle
            variant="white"
            id="dropdown-compras-mes"
            style={{ ...filterStyle, textAlign: "left", background: "#fff" }}
            className={comprasMeses.length > 0 ? styles.activeFilter : ""}
          >
            {/* Resumen compacto (mismo patrón que el filtro de Ventas): 0 → "Meses"; 1-3 por
                nombre; todos los periodos disponibles → "Todos"; el resto → "N meses". Compras
                solo cubre corte→mes actual, así que "Todos" compara contra periodos.length (no 12).
                Solo cambia el texto mostrado, no comprasMeses ni el filtro. */}
            {comprasMeses.length === 0
              ? "Meses"
              : comprasMeses.length <= 3
                ? [...comprasMeses].sort().map((p) => getPeriodoLabel(p)).join(", ")
                : comprasMeses.length === periodos.length
                  ? "Todos"
                  : `${comprasMeses.length} meses`}
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ maxHeight: "370px", overflowY: "auto" }}>
            {/* Atajos de agrupación: cada uno tilda los meses (existentes) de su rango.
                Los periodos solo cubren corte→mes actual, así que un Q/H futuro tilda lo que
                haya. Los checkboxes de meses siguen por debajo. */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: 4, padding: "2px 8px 8px" }}>
              {[
                { label: "Q1", desde: 1, hasta: 3 },
                { label: "Q2", desde: 4, hasta: 6 },
                { label: "Q3", desde: 7, hasta: 9 },
                { label: "Q4", desde: 10, hasta: 12 },
                { label: "H1", desde: 1, hasta: 6 },
                { label: "H2", desde: 7, hasta: 12 },
              ].map((rango) => (
                <button
                  key={rango.label}
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  style={{ fontSize: "0.65rem", padding: "1px 6px" }}
                  onClick={() =>
                    setComprasMeses(
                      periodos.filter((p) => {
                        const mes = parseInt(p.split("-")[1], 10);
                        return mes >= rango.desde && mes <= rango.hasta;
                      })
                    )
                  }
                >
                  {rango.label}
                </button>
              ))}
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                style={{ fontSize: "0.65rem", padding: "1px 6px" }}
                onClick={() => setComprasMeses([])}
              >
                Todo
              </button>
            </div>
            {/* Ascendente (Ene arriba → Dic abajo): `periodos` está en orden descendente. */}
            {[...periodos].sort().map((p) => (
              <div key={p} className="form-check-facturas" style={{ marginBottom: "5px" }}>
                <input
                  className={styles.checkboxInput}
                  type="checkbox"
                  id={`compras-mes-${p}`}
                  value={p}
                  checked={comprasMeses.includes(p)}
                  onChange={(e) => handleComprasMesChange(e.target.value)}
                />
                <label className={styles.checkboxLabel} htmlFor={`compras-mes-${p}`}>
                  {getPeriodoLabel(p)}
                </label>
              </div>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <select value={comprasTipo} onChange={(e) => setComprasTipo(e.target.value)} style={filterStyle}>
          {OPCIONES_TIPO.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <select
          value={comprasClasificacion}
          onChange={(e) => setComprasClasificacion(e.target.value)}
          style={filterStyle}
        >
          {OPCIONES_CLASIFICACION.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
          {CUENTAS_AGRUPADAS.map(({ grupo, cuentas }) => (
            <optgroup key={grupo} label={grupo}>
              {cuentas.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
        <select value={comprasPago} onChange={(e) => setComprasPago(e.target.value)} style={filterStyle}>
          {OPCIONES_PAGO.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <select value={comprasEstadoSii} onChange={(e) => setComprasEstadoSii(e.target.value)} style={filterStyle}>
          {OPCIONES_ESTADO_SII.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Buscar proveedor, RUT o folio..."
          value={comprasBusqueda}
          onChange={(e) => setComprasBusqueda(e.target.value)}
          style={filterStyle}
        />
      </div>
    );
  };

  // Header ordenable del tab "ventas": click / Enter / Space ciclan asc→desc→natural.
  // aria-sort + tabIndex + onKeyDown para operarlo por teclado (accesibilidad que
  // EdificiosTable no tiene; se completa acá). Estilo por CSS module (regla 10.6).
  const renderThOrdenable = (key, label, className) => {
    const dir = sortConfig.key === key ? sortConfig.dir : null;
    const ariaSort = dir === "asc" ? "ascending" : dir === "desc" ? "descending" : "none";
    return (
      <th
        scope="col"
        className={`${className} ${styles.sortableHeader}`}
        onClick={() => handleSort(key)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleSort(key);
          }
        }}
        tabIndex={0}
        aria-sort={ariaSort}
      >
        {label}
        {sortIndicator(key)}
      </th>
    );
  };

  // ─── Render functions por tipo de vista ──────────────────────
  const renderTablePublicidad = () => (
    <div className={styles.tableResponsive}>
      <table className={`table table-hover table-striped ${styles.table}`}>
        <thead className="text-center align-middle">
          <tr>
            <th className={styles.colStatus}>ID</th>
            {renderThOrdenable("ejecutivo", "EJECUTIVO", styles.colEjecutivo)}
            {renderThOrdenable("folio", "Nº FACTURA", styles.colNumeroFactura)}
            {renderThOrdenable("fechaFactura", "FECHA FACTURA", styles.colFechaFactura)}
            {renderThOrdenable("cliente", "CLIENTE", styles.colCliente)}
            {renderThOrdenable("intermediario", "INTERMEDIARIO", styles.colIntermediario)}
            {renderThOrdenable("venta", "VENTA", styles.colVenta)}
            {renderThOrdenable("comisionPct", "COMISIÓN %", styles.colComision)}
            {renderThOrdenable("comisionMonto", `COMISIÓN ${displayMoneda}`, styles.colComision)}
            {renderThOrdenable("neto", "NETO", styles.colNeto)}
            <th className={styles.colSii}>{esChile ? "SII" : "SUNAT"}</th>
            <th className={styles.colFactoring}>FINANCIACIÓN</th>
            {renderThOrdenable("cobro", "COBRO", styles.colCobrada)}
            {!esChile && <th className={styles.colEditar}>EDIT</th>}
          </tr>
        </thead>
        <tbody>
          {filasVentasOrdenadas.length === 0 ? (
            <tr>
              <td colSpan={esChile ? 13 : 14} className="text-center">
                No hay facturas ni ventas según los filtros seleccionados
              </td>
            </tr>
          ) : (
            filasVentasOrdenadas.map(({ op: oportunidad, calc }) => {
              const {
                id,
                display_id,
                type,
                ejecutivoNombre,
                facturafecha,
                cliente,
                intermediario,
                facturafechacobro,
                plazocobro,
                mes,
                ano,
                client_id,
                moneda_dolar,
                descuento_acuerdo_pct,
                contrato_id,
              } = oportunidad;

              const vincSII = getVinculacionSII(oportunidad);
              const displayFolio = getDisplayFolio(oportunidad, vincSII);
              const displayFechaFact = facturafecha || (vincSII?.fechaEmision || null);
              const estado = getEstadoCobro(facturafecha, facturafechacobro, plazocobro, tieneVinculacionSII(oportunidad));

              // Badge de acuerdo de volumen (OMNET). Fase B (7.22): se dibuja cuando la venta lleva
              // descuento de acuerdo (`descuento_acuerdo_pct>0`) — el override quedó muerto. El
              // intermediario se resuelve por holding (regla 10.7, fuente única `resolverVolumenInter`);
              // se muestra el segmento corto tras "|".
              const volumenInter =
                (Number(descuento_acuerdo_pct) || 0) > 0
                  ? resolverVolumenInter(client_id, clientes, intermediarios)
                  : null;
              const overrideBadge = volumenInter?.nombre ? volumenInter.nombre.split("|").pop().trim() : null;

              // ID legible: los contratos sin display_id caen al id compuesto
              // "contrato-{id}-{idx}" (se recortaba a "cont..."); mostramos "C-{contrato_id}".
              const idLegible = display_id || (type === "contrato" ? `C-${contrato_id}` : id);

              return (
                <tr key={id}>
                  <td className={`${styles.colStatus} bg-success text-white`}>
                    {idLegible}
                  </td>
                  <td className={styles.colEjecutivo}>{ejecutivoNombre}</td>
                  <td className={styles.colNumeroFactura}>
                    {displayFolio || (
                      <span style={{ color: facturafecha ? "#dc3545" : undefined, fontWeight: facturafecha ? 600 : undefined }}>
                        -
                      </span>
                    )}
                  </td>
                  <td className={styles.colFechaFactura}>
                    {displayFechaFact ? (
                      <span style={{ color: "black" }}>
                        {fechaLocal(displayFechaFact).toLocaleDateString("es-ES", fecha)}
                      </span>
                    ) : (
                      <span style={{ color: "red" }}>
                        {mes && ano ? `${mesEnLetras(mes)}/${ano.slice(-2)}` : "-"}
                      </span>
                    )}
                  </td>
                  <td className={styles.colCliente}>{(cliente || "").toUpperCase()}</td>
                  <td className={styles.colIntermediario}>
                    <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                      <span>{intermediario}</span>
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
                        {overrideBadge && (
                          <span
                            title={`Acuerdo de volumen: ${volumenInter.nombre}`}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              background: "#6f42c1",
                              color: "#fff",
                              fontSize: "0.6rem",
                              fontWeight: 700,
                              letterSpacing: "0.02em",
                              padding: "1px 6px",
                              borderRadius: 8,
                              whiteSpace: "nowrap",
                              flexShrink: 0,
                            }}
                          >
                            {overrideBadge}
                          </span>
                        )}
                        {calc.apxPct > 0 && (
                          <span
                            title={`APX (Publicis): +${calc.apxPct}% sobre bruto`}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              background: "#20c997",
                              color: "#fff",
                              fontSize: "0.6rem",
                              fontWeight: 700,
                              letterSpacing: "0.02em",
                              padding: "1px 6px",
                              borderRadius: 8,
                              whiteSpace: "nowrap",
                              flexShrink: 0,
                            }}
                          >
                            APX
                          </span>
                        )}
                      </span>
                    </span>
                  </td>
                  <td className={`${styles.colVenta} text-end`}>
                    {`${moneda_dolar ? "US$" : moneda(pais)} ${calc.ventaNativa.toLocaleString(
                      getLocale(pais),
                      {
                        maximumFractionDigits: decimales(pais),
                        minimumFractionDigits: decimales(pais),
                      }
                    )}`}
                  </td>
                  <td className={`${styles.colComision} text-center`}>
                    {calc.comisionPct.toFixed(1)}%
                  </td>
                  <td className={`${styles.colComision} text-end`}>
                    {`${displayMoneda} ${calc.comisionConApx.toLocaleString(getLocale(pais), {
                      maximumFractionDigits: displayDecimales,
                      minimumFractionDigits: displayDecimales,
                    })}`}
                  </td>
                  <td className={`${styles.colNeto} text-end`}>
                    {`${displayMoneda} ${calc.netoDisplay.toLocaleString(getLocale(pais), {
                      maximumFractionDigits: displayDecimales,
                      minimumFractionDigits: displayDecimales,
                    })}`}
                  </td>
                  <td className={styles.colSii}>
                    {tieneVinculacionSII(oportunidad) ? (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#27ae60",
                          color: "#fff",
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          width: 18,
                          height: 18,
                          borderRadius: 4,
                        }}
                        title={`Vinculada en ${esChile ? "SII" : "SUNAT"}`}
                      >
                        ✓
                      </span>
                    ) : (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#e67e22",
                          color: "#fff",
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          width: 18,
                          height: 18,
                          borderRadius: 4,
                        }}
                        title={`No vinculada en ${esChile ? "SII" : "SUNAT"}`}
                      >
                        P
                      </span>
                    )}
                  </td>
                  <td className={`${styles.colFactoring} ${styles.colFactoringTd}`}>{renderColumnaFactoring(oportunidad)}</td>
                  <td
                    className={styles.colCobrada}
                    style={{
                      backgroundColor: estado.bg,
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    {estado.text}
                  </td>
                  {!esChile && (
                    <td className={`${styles.colEditar} text-center align-middle`}>
                      <FaEdit
                        onClick={puedeEditar(oportunidad) ? () => handleOpenModal(oportunidad) : undefined}
                        style={{
                          cursor: puedeEditar(oportunidad) ? "pointer" : "not-allowed",
                          fontSize: "1.2em",
                          opacity: puedeEditar(oportunidad) ? 1 : 0.4,
                        }}
                      />
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );

  // ─── Badges de tipo ───
  const tipoBadge = (type) => {
    const map = {
      pauta: { label: "P", bg: "#8e44ad" },
      contrato: { label: "P", bg: "#8e44ad" },
      "HW-CAPEX": { label: "H", bg: "#e67e22" },
      "HW-OPEX": { label: "H", bg: "#e67e22" },
      Gestión: { label: "G", bg: "#2980b9" },
      BTL: { label: "B", bg: "#27ae60" },
      Contenidos: { label: "C", bg: "#d63384" },
    };
    const info = map[type] || { label: "?", bg: "#999" };
    return (
      <span
        key={type}
        style={{
          display: "inline-block",
          background: info.bg,
          color: "#fff",
          fontSize: "0.65rem",
          fontWeight: 700,
          width: 20,
          height: 20,
          borderRadius: 4,
          textAlign: "center",
          lineHeight: "20px",
        }}
        title={type}
      >
        {info.label}
      </span>
    );
  };

  // ─── Agrupar oportunidades por factura para vista TODO ───
  const agruparPorFactura = (ops) => {
    const grupos = [];
    const facturasVistas = {};

    for (const op of ops) {
      // Solo agrupar cartelería (HW-OPEX, Gestión) que comparten negocio_id + folio
      const esCarteleria = ["HW-OPEX", "Gestión"].includes(op.type);
      const folio = getDisplayFolio(op);

      if (esCarteleria && folio && op.negocio_id) {
        const key = `${op.negocio_id}-${folio}`;
        const tiposOp = [op.type];
        if (op.incluye_contenidos) tiposOp.push("Contenidos");
        if (facturasVistas[key]) {
          facturasVistas[key].items.push(op);
          facturasVistas[key].tipos.push(...tiposOp);
          facturasVistas[key].importeTotal += getImporteFacturable(op);
        } else {
          facturasVistas[key] = { items: [op], tipos: [...tiposOp], importeTotal: getImporteFacturable(op) };
          grupos.push({ key, grouped: true, ref: facturasVistas[key] });
        }
      } else {
        const tiposOp = [op.type];
        if (op.type === "Gestión" && op.incluye_contenidos) tiposOp.push("Contenidos");
        grupos.push({ key: `${op.type}-${op.id}`, grouped: false, op, tiposOverride: tiposOp });
      }
    }
    return grupos;
  };

  const renderTableSummary = () => {
    const grupos = agruparPorFactura(oportunidadesFiltradas);

    return (
      <div className={styles.tableResponsive}>
        <table className={`table table-hover table-striped ${styles.table}`}>
          <thead className="text-center align-middle">
            <tr style={{ height: 48 }}>
              <th className={styles.colSumTipo}>TIPO</th>
              <th className={styles.colSumEjecutivo}>EJECUTIVO</th>
              <th className={styles.colSumCliente}>CLIENTE</th>
              <th className={styles.colSumImporte}>IMPORTE NETO</th>
              <th className={styles.colSumSii}>{esChile ? "SII" : "SUNAT"}</th>
              <th className={styles.colSumNumeroFactura}>Nº FACTURA</th>
              <th className={styles.colSumFechaFactura}>FECHA FACTURA</th>
              <th className={styles.colFactoring}>FINANCIACIÓN</th>
              <th className={styles.colSumCobrada}>FECHA COBRO</th>
            </tr>
          </thead>
          <tbody>
            {grupos.length === 0 ? (
              <tr>
                <td colSpan="9" className="text-center">
                  No hay facturas ni ventas según los filtros seleccionados
                </td>
              </tr>
            ) : (
              grupos.map((grupo) => {
                // Determinar la oportunidad principal (primera del grupo o la única)
                const oportunidad = grupo.grouped ? grupo.ref.items[0] : grupo.op;
                const tipos = grupo.grouped
                  ? [...new Set(grupo.ref.tipos)]
                  : [...new Set(grupo.tiposOverride || [oportunidad.type])];
                const {
                  id, ejecutivoNombre, facturafecha, cliente,
                  facturafechacobro, plazocobro, mes, ano, moneda_dolar,
                } = oportunidad;

                const vincSII = getVinculacionSII(oportunidad);
                const displayFolio = getDisplayFolio(oportunidad, vincSII);
                const displayFechaFact = facturafecha || (vincSII?.fechaEmision || null);
                const estado = getEstadoCobro(
                  facturafecha, facturafechacobro, plazocobro, tieneVinculacionSII(oportunidad)
                );

                // Importe: para grupos usar SII total si disponible, sino sumar importes (facturable,
                // 7.22 — coherente con la tabla detalle: OMNET muestra el 75%, no la lista).
                const importeDisplay = (() => {
                  if (!moneda_dolar && vincSII?.montoNeto) return vincSII.montoNeto;
                  return grupo.grouped ? grupo.ref.importeTotal : getImporteFacturable(oportunidad);
                })();

                return (
                  <tr key={grupo.key}>
                    <td className={styles.colSumTipo} style={{ textAlign: "center" }}>
                      <div style={{ display: "flex", gap: 3, justifyContent: "center", alignItems: "center" }}>
                        {tipos.map((t) => tipoBadge(t))}
                      </div>
                    </td>
                    <td className={styles.colSumEjecutivo}>{ejecutivoNombre}</td>
                    <td className={styles.colSumCliente}>{(cliente || "").toUpperCase()}</td>
                    <td className={`${styles.colSumImporte} text-end`} style={{ position: "relative" }}>
                      {(() => {
                        // El "!" flaguea divergencia real DTE vs facturable (7.22), no el descuento
                        // de acuerdo: se compara contra getImporteFacturable, no contra el importe lista.
                        const importeRegistrado = grupo.grouped
                          ? grupo.ref.importeTotal
                          : getImporteFacturable(oportunidad);
                        const siiNeto = !moneda_dolar && vincSII?.montoNeto;
                        const difiere = siiNeto && Math.abs(siiNeto - importeRegistrado) > TOLERANCIA_MONTO_FACTURABLE;
                        return (
                          <>
                            {difiere && (
                              <span
                                title={`Registrado: ${moneda(pais)} ${importeRegistrado.toLocaleString(getLocale(pais))}`}
                                style={{
                                  position: "absolute",
                                  left: 4,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  background: "#c0392b",
                                  color: "#fff",
                                  fontSize: "0.6rem",
                                  fontWeight: 700,
                                  width: 16,
                                  height: 16,
                                  borderRadius: 3,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "help",
                                }}
                              >
                                !
                              </span>
                            )}
                            {`${moneda_dolar ? "US$" : moneda(pais)} ${importeDisplay.toLocaleString(
                              getLocale(pais),
                              {
                                maximumFractionDigits: decimales(pais),
                                minimumFractionDigits: decimales(pais),
                              }
                            )}`}
                          </>
                        );
                      })()}
                    </td>
                    <td
                      style={{ textAlign: "center", cursor: "pointer" }}
                      onClick={() => setSiiModalOportunidad(oportunidad)}
                    >
                      {tieneVinculacionSII(oportunidad) ? (
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#27ae60",
                            color: "#fff",
                            fontSize: "0.65rem",
                            fontWeight: 700,
                            width: 18,
                            height: 18,
                            borderRadius: 4,
                          }}
                          title={`Vinculada en ${esChile ? "SII" : "SUNAT"}`}
                        >
                          ✓
                        </span>
                      ) : (
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#e67e22",
                            color: "#fff",
                            fontSize: "0.65rem",
                            fontWeight: 700,
                            width: 18,
                            height: 18,
                            borderRadius: 4,
                          }}
                          title={`No vinculada en ${esChile ? "SII" : "SUNAT"}`}
                        >
                          P
                        </span>
                      )}
                    </td>
                    <td className={styles.colSumNumeroFactura}>
                      {displayFolio || (
                        <span
                          style={{
                            color: facturafecha ? "#dc3545" : undefined,
                            fontWeight: facturafecha ? 600 : undefined,
                          }}
                        >
                          -
                        </span>
                      )}
                    </td>
                    <td className={styles.colSumFechaFactura}>
                      {displayFechaFact ? (
                        <span style={{ color: "black" }}>
                          {fechaLocal(displayFechaFact).toLocaleDateString("es-ES", fecha)}
                        </span>
                      ) : (
                        <span style={{ color: "red" }}>
                          {mes && ano ? `${mesEnLetras(mes)}/${ano.slice(-2)}` : "-"}
                        </span>
                      )}
                    </td>
                    <td className={`${styles.colFactoring} ${styles.colFactoringTd}`}>{renderColumnaFactoring(oportunidad)}</td>
                    {(() => {
                      const editable = !estado.cobrada && estado.text !== "Sin facturar";
                      return (
                        <td
                          className={styles.colSumCobrada}
                          style={{
                            backgroundColor: estado.bg,
                            color: "white",
                            fontWeight: "500",
                            cursor: editable ? "pointer" : "default",
                          }}
                          onClick={(e) => {
                            if (!editable) return;
                            const rect = e.currentTarget.getBoundingClientRect();
                            setCobroPickerOp(
                              cobroPickerOp?.id === id && cobroPickerOp?.type === oportunidad.type
                                ? null
                                : {
                                    ...oportunidad,
                                    _pickerTop: rect.bottom,
                                    _pickerRight: window.innerWidth - rect.right,
                                  }
                            );
                          }}
                        >
                          {estado.text}
                        </td>
                      );
                    })()}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const renderTableHardware = () => (
    <div className={styles.tableResponsive}>
      <table className={`table table-hover table-striped ${styles.table}`}>
        <thead className="text-center align-middle">
          <tr>
            <th className={styles.colHwId} rowSpan="2">ID</th>
            <th className={styles.colHwEjecutivo} rowSpan="2">EJECUTIVO</th>
            <th className={styles.colHwCliente} rowSpan="2">CLIENTE</th>
            <th colSpan="2" className={styles.colHwCuotaHeader}>CUOTA</th>
            <th className={styles.colHwModalidad} rowSpan="2">MODALIDAD</th>
            <th className={styles.colHwNumeroFactura} rowSpan="2">Nº FACTURA</th>
            <th className={styles.colHwFechaFactura} rowSpan="2">FECHA FACTURA</th>
            <th className={styles.colHwImporte} rowSpan="2">IMPORTE NETO</th>
            <th className={styles.colHwSii} rowSpan="2">{esChile ? "SII" : "SUNAT"}</th>
            <th className={styles.colFactoring} rowSpan="2">FINANCIACIÓN</th>
            <th className={styles.colHwCobrada} rowSpan="2">COBRO</th>
            {!esChile && <th className={styles.colHwEditar} rowSpan="2">EDIT</th>}
          </tr>
          <tr>
            <th className={styles.colHwValorCuota}>VALOR</th>
            <th className={styles.colHwCuota}>PERIODO</th>
          </tr>
        </thead>
        <tbody>
          {oportunidadesFiltradas.length === 0 ? (
            <tr>
              <td colSpan={esChile ? 12 : 13} className="text-center">
                No hay facturas de hardware según los filtros seleccionados
              </td>
            </tr>
          ) : (
            oportunidadesFiltradas.map((oportunidad) => {
              const {
                id,
                display_id,
                type,
                ejecutivoNombre,
                facturafecha,
                cliente,
                facturafechacobro,
                plazocobro,
                mes,
                ano,
                label_extra,
                valor_cuota,
                moneda_cuota,
                moneda_dolar,
                importe,
                feeProporcion,
              } = oportunidad;

              const estado = getEstadoCobro(facturafecha, facturafechacobro, plazocobro, tieneVinculacionSII(oportunidad));
              const displayFolio = getDisplayFolio(oportunidad);

              // UF: "2,46 UF" (número + código). Moneda: mismo formato con símbolo que el resto de
              // la grilla (celda IMPORTE NETO) → CLP "$ 3.333.087", USD "US$ ...", vía moneda(pais)/
              // decimales(pais) — no un formateador nuevo (10.1).
              const valorCuotaDisplay = valor_cuota
                ? moneda_cuota === "UF"
                  ? `${valor_cuota.toLocaleString(getLocale(pais), {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                  })} UF`
                  : `${moneda_cuota === "USD" ? "US$" : moneda(pais)} ${valor_cuota.toLocaleString(getLocale(pais), {
                    maximumFractionDigits: decimales(pais),
                    minimumFractionDigits: decimales(pais),
                  })}`
                : "-";

              return (
                <tr key={id}>
                  <td className={`${styles.colHwId} bg-success text-white`}>{display_id || id}</td>
                  <td className={styles.colHwEjecutivo}>{ejecutivoNombre}</td>
                  <td className={styles.colHwCliente}>{(cliente || "").toUpperCase()}</td>
                  <td className={`${styles.colHwValorCuota} text-center`}>{valorCuotaDisplay}</td>
                  <td className={`${styles.colHwCuota} text-center`}>{label_extra || "-"}</td>
                  <td className={styles.colHwModalidad}>
                    {type === "HW-CAPEX" ? "CAPEX" : "OPEX"}
                  </td>
                  <td className={styles.colHwNumeroFactura}>
                    {displayFolio || (
                      <span style={{ color: facturafecha ? "#dc3545" : undefined, fontWeight: facturafecha ? 600 : undefined }}>
                        -
                      </span>
                    )}
                  </td>
                  <td className={styles.colHwFechaFactura}>
                    {facturafecha ? (
                      <span style={{ color: "black" }}>
                        {fechaLocal(facturafecha).toLocaleDateString("es-ES", fecha)}
                      </span>
                    ) : (
                      <span style={{ color: "red" }}>
                        {mes && ano ? `${mesEnLetras(mes)}/${ano.slice(-2)}` : "-"}
                      </span>
                    )}
                  </td>
                  <td className={`${styles.colHwImporte} text-end`}>
                    {(() => {
                      const vincSII = getVinculacionSII(oportunidad);
                      const siiNeto = !moneda_dolar && vincSII?.montoNeto;
                      const importeDisplay = siiNeto
                        ? Math.round(siiNeto * (feeProporcion || 1))
                        : (importe || 0);
                      return `${moneda_dolar ? "US$" : moneda(pais)} ${importeDisplay.toLocaleString(
                        getLocale(pais),
                        {
                          maximumFractionDigits: decimales(pais),
                          minimumFractionDigits: decimales(pais),
                        }
                      )}`;
                    })()}
                  </td>
                  <td className={styles.colHwSii}>
                    {tieneVinculacionSII(oportunidad) ? (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#27ae60",
                          color: "#fff",
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          width: 18,
                          height: 18,
                          borderRadius: 4,
                        }}
                        title={`Vinculada en ${esChile ? "SII" : "SUNAT"}`}
                      >
                        ✓
                      </span>
                    ) : (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#e67e22",
                          color: "#fff",
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          width: 18,
                          height: 18,
                          borderRadius: 4,
                        }}
                        title={`No vinculada en ${esChile ? "SII" : "SUNAT"}`}
                      >
                        P
                      </span>
                    )}
                  </td>
                  <td className={`${styles.colFactoring} ${styles.colFactoringTd}`}>{renderColumnaFactoring(oportunidad)}</td>
                  <td
                    className={styles.colHwCobrada}
                    style={{
                      backgroundColor: estado.bg,
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    {estado.text}
                  </td>
                  {!esChile && (
                    <td className={`${styles.colHwEditar} text-center align-middle`}>
                      {(() => {
                        const editable = type === "HW-CAPEX"
                          ? puedeEditar(oportunidad)
                          : puedeEditar(oportunidad) && esCuotaEditable(mes, ano);
                        return (
                          <FaEdit
                            onClick={editable ? () => handleOpenModal(oportunidad) : undefined}
                            style={{
                              cursor: editable ? "pointer" : "not-allowed",
                              fontSize: "1.2em",
                              opacity: editable ? 1 : 0.4,
                            }}
                          />
                        );
                      })()}
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );

  const renderTableGestion = () => (
    <div className={styles.tableResponsive}>
      <table className={`table table-hover table-striped ${styles.table}`}>
        <thead className="text-center align-middle">
          <tr>
            <th className={styles.colGesId} rowSpan="2">ID</th>
            <th className={styles.colGesEjecutivo} rowSpan="2">EJECUTIVO</th>
            <th className={styles.colGesCliente} rowSpan="2">CLIENTE</th>
            <th className={styles.colGesCuota} rowSpan="2">PERIODO</th>
            <th colSpan="2" className={styles.colGesCuotaHeader}>CUOTA</th>
            <th className={styles.colGesNumeroFactura} rowSpan="2">Nº FACTURA</th>
            <th className={styles.colGesFechaFactura} rowSpan="2">FECHA FACTURA</th>
            <th className={styles.colGesImporte} rowSpan="2">IMPORTE NETO</th>
            <th className={styles.colGesSii} rowSpan="2">{esChile ? "SII" : "SUNAT"}</th>
            <th className={styles.colFactoring} rowSpan="2">FINANCIACIÓN</th>
            <th className={styles.colGesCobrada} rowSpan="2">COBRO</th>
            {!esChile && <th className={styles.colGesEditar} rowSpan="2">EDIT</th>}
          </tr>
          <tr>
            <th className={styles.colGesValorCuota}>GESTIÓN</th>
            <th className={styles.colGesContenidos}>CONTENIDOS</th>
          </tr>
        </thead>
        <tbody>
          {oportunidadesFiltradas.length === 0 ? (
            <tr>
              <td colSpan={esChile ? 11 : 12} className="text-center">
                No hay facturas de gestión según los filtros seleccionados
              </td>
            </tr>
          ) : (
            oportunidadesFiltradas.map((oportunidad) => {
              const {
                id,
                display_id,
                ejecutivoNombre,
                facturafecha,
                cliente,
                facturafechacobro,
                plazocobro,
                mes,
                ano,
                label_extra,
                moneda_dolar,
                importe,
                incluye_contenidos,
                feeGestionUF,
                feeContenidosUF,
                feeContenidosCLP,
                feeProporcion,
              } = oportunidad;

              const estado = getEstadoCobro(facturafecha, facturafechacobro, plazocobro, tieneVinculacionSII(oportunidad));
              const displayFolio = getDisplayFolio(oportunidad);

              const fmtUF = (val) =>
                val
                  ? `${val.toLocaleString(getLocale(pais), { maximumFractionDigits: 2, minimumFractionDigits: 2 })} UF`
                  : null;

              const fmtCLP = (val) =>
                val
                  ? `${moneda(pais)} ${val.toLocaleString(getLocale(pais), { maximumFractionDigits: 0 })}`
                  : null;

              return (
                <tr key={id}>
                  <td className={`${styles.colGesId} bg-success text-white`}>{display_id || id}</td>
                  <td className={styles.colGesEjecutivo}>{ejecutivoNombre}</td>
                  <td className={styles.colGesCliente}>{(cliente || "").toUpperCase()}</td>
                  <td className={`${styles.colGesCuota} text-center`}>{label_extra || "-"}</td>
                  <td className={`${styles.colGesValorCuota} text-center`}>{fmtUF(feeGestionUF) || "—"}</td>
                  <td className={`${styles.colGesContenidos} text-center`}>
                    {incluye_contenidos ? (fmtUF(feeContenidosUF) || fmtCLP(feeContenidosCLP) || "—") : "—"}
                  </td>
                  <td className={styles.colGesNumeroFactura}>
                    {displayFolio || (
                      <span style={{ color: facturafecha ? "#dc3545" : undefined, fontWeight: facturafecha ? 600 : undefined }}>
                        -
                      </span>
                    )}
                  </td>
                  <td className={styles.colGesFechaFactura}>
                    {facturafecha ? (
                      <span style={{ color: "black" }}>
                        {fechaLocal(facturafecha).toLocaleDateString("es-ES", fecha)}
                      </span>
                    ) : (
                      <span style={{ color: "red" }}>
                        {mes && ano ? `${mesEnLetras(mes)}/${ano.slice(-2)}` : "-"}
                      </span>
                    )}
                  </td>
                  <td className={`${styles.colGesImporte} text-end`}>
                    {(() => {
                      const vincSII = getVinculacionSII(oportunidad);
                      const siiNeto = !moneda_dolar && vincSII?.montoNeto;
                      const importeDisplay = siiNeto
                        ? Math.round(siiNeto * (feeProporcion || 1))
                        : (importe || 0);
                      return `${moneda_dolar ? "US$" : moneda(pais)} ${importeDisplay.toLocaleString(
                        getLocale(pais),
                        {
                          maximumFractionDigits: decimales(pais),
                          minimumFractionDigits: decimales(pais),
                        }
                      )}`;
                    })()}
                  </td>
                  <td className={styles.colGesSii}>
                    {tieneVinculacionSII(oportunidad) ? (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#27ae60",
                          color: "#fff",
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          width: 18,
                          height: 18,
                          borderRadius: 4,
                        }}
                        title={`Vinculada en ${esChile ? "SII" : "SUNAT"}`}
                      >
                        ✓
                      </span>
                    ) : (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#e67e22",
                          color: "#fff",
                          fontSize: "0.65rem",
                          fontWeight: 700,
                          width: 18,
                          height: 18,
                          borderRadius: 4,
                        }}
                        title={`No vinculada en ${esChile ? "SII" : "SUNAT"}`}
                      >
                        P
                      </span>
                    )}
                  </td>
                  <td className={`${styles.colFactoring} ${styles.colFactoringTd}`}>{renderColumnaFactoring(oportunidad)}</td>
                  <td
                    className={styles.colGesCobrada}
                    style={{
                      backgroundColor: estado.bg,
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    {estado.text}
                  </td>
                  {!esChile && (
                    <td className={`${styles.colGesEditar} text-center align-middle`}>
                      <FaEdit
                        onClick={
                          puedeEditar(oportunidad) && esCuotaEditable(mes, ano)
                            ? () => handleOpenModal(oportunidad)
                            : undefined
                        }
                        style={{
                          cursor: puedeEditar(oportunidad) && esCuotaEditable(mes, ano) ? "pointer" : "not-allowed",
                          fontSize: "1.2em",
                          opacity: puedeEditar(oportunidad) && esCuotaEditable(mes, ano) ? 1 : 0.4,
                        }}
                      />
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className={styles.containerFacturasDetalle}>
      <Header
        leftContent={
          <div
            style={{
              display: "flex",
              gap: 0,
              borderRadius: 6,
              overflow: "visible",
              border: "1px solid #dee2e6",
              marginLeft: 150,
            }}
          >
            {["ventas", "compras"].map((tab) => (
              <button
                key={tab}
                onClick={() => setTabActivo(tab)}
                style={{
                  position: "relative",
                  padding: "6px 0",
                  width: 110,
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  border: "none",
                  borderRadius: tab === "ventas" ? "6px 0 0 6px" : "0 6px 6px 0",
                  cursor: "pointer",
                  background: tabActivo === tab ? "#2c3e50" : "transparent",
                  color: tabActivo === tab ? "#fff" : "#666",
                  textTransform: "capitalize",
                }}
              >
                {tab === "ventas" ? "Ventas" : "Compras"}
                {tab === "compras" && comprasSinClasificarCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: -6,
                      right: -6,
                      minWidth: 18,
                      height: 18,
                      padding: "0 4px",
                      borderRadius: 9,
                      background: "#c62828",
                      color: "#fff",
                      fontSize: "0.6rem",
                      fontWeight: 700,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2,
                    }}
                  >
                    {comprasSinClasificarCount}
                  </span>
                )}
              </button>
            ))}
          </div>
        }
        centerContent={tabActivo === "ventas" ? renderFilters() : renderFiltrosCompras()}
      >
        <button
          type="button"
          onClick={handleSyncSII}
          disabled={sincronizandoSII}
          style={{
            padding: "6px 14px",
            fontSize: "0.78rem",
            fontWeight: 600,
            border: "1px solid #1a5632",
            borderRadius: 6,
            background: sincronizandoSII ? "#95a5a6" : "#1a5632",
            color: "#fff",
            cursor: sincronizandoSII ? "not-allowed" : "pointer",
          }}
        >
          {sincronizandoSII ? "Sincronizando..." : `Sincronizar ${esChile ? "SII" : "SUNAT"}`}
        </button>
      </Header>

      {tabActivo === "compras" && (
        <ComprasTab
          pais={pais}
          filtros={{
            meses: comprasMeses,
            clasificacion: comprasClasificacion,
            tipo: comprasTipo,
            pago: comprasPago,
            estadoSii: comprasEstadoSii,
            busqueda: comprasBusqueda,
          }}
          reloadNonce={comprasSyncNonce}
        />
      )}

      {/* Filtros por vertical */}
      <div className={styles.tipoButtons} style={{ display: tabActivo === "ventas" ? "grid" : "none" }}>
        {[
          { value: "", label: "TODO", pctKey: null, color: "#6c757d" },
          { value: "publicidad", label: "PUBLICIDAD", pctKey: "publicidad", color: "#0d6efd" },
          { value: "hardware", label: "HARDWARE", pctKey: "hardware", color: "#198754" },
          { value: "Gestión", label: "GESTIÓN", pctKey: "gestion", color: "#6f42c1" },
          { value: "BTL", label: "BTL", pctKey: "btl", color: "#fd7e14" },
        ].map((opt) => {
          const pct = opt.pctKey ? porcentajesVertical[opt.pctKey] : null;
          const isActive = filtroTipo === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              className={`${styles.tipoBtn} ${isActive ? styles.tipoBtnActive : ""}`}
              style={isActive ? { borderColor: opt.color, backgroundColor: `${opt.color}0D` } : {}}
              onClick={() => {
                const newVal = filtroTipo === opt.value ? "" : opt.value;
                setFiltroTipo(newVal);
                if (newVal !== "hardware") setFiltroModalidad("");
              }}
            >
              <span
                className={styles.tipoBtnCheck}
                style={isActive ? { backgroundColor: opt.color, borderColor: opt.color } : {}}
              >
                {isActive && (
                  <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                    <path d="M1 3.5L3.5 6L9 1" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </span>
              <span className={styles.tipoBtnLabel}>{opt.label}</span>
              <span className={styles.tipoBtnPct}>{pct != null ? `${pct}%` : ""}</span>
            </button>
          );
        })}
      </div>

      {/* Cards de totales */}
      <div className={styles.cardsSection} style={{ display: tabActivo === "ventas" ? "grid" : "none" }}>
        <div className={styles.card}>
          <div className={styles.cardLabel}>BRUTO</div>
          <div className={styles.cardValue}>
            {`${displayMoneda} ${(totales.totalVenta || 0).toLocaleString(getLocale(pais), {
              maximumFractionDigits: displayDecimales,
              minimumFractionDigits: displayDecimales,
            })}`}
          </div>
        </div>
        <div className={`${styles.card} ${styles.cardGreen}`}>
          <div className={styles.cardLabel}>FACTURADO</div>
          <div className={styles.cardValue}>{`${(totales.porcentajeFacturado || 0).toFixed(0)}%`}</div>
        </div>
        <div className={`${styles.card} ${styles.cardRed}`}>
          <div className={styles.cardLabel}>PENDIENTE</div>
          <div className={styles.cardValue}>{`${(100 - (totales.porcentajeFacturado || 0)).toFixed(0)}%`}</div>
        </div>
        <div className={styles.card}>
          <div className={styles.cardLabel}>INTERMEDIACIÓN</div>
          <div className={styles.cardValue}>
            {!filtroTipo || ["publicidad", "BTL"].includes(filtroTipo)
              ? `${displayMoneda} ${(totales.totalComisionIntermediario || 0).toLocaleString(
                getLocale(pais),
                { maximumFractionDigits: displayDecimales, minimumFractionDigits: displayDecimales }
              )}`
              : "-"}
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.cardLabel}>NETO</div>
          <div className={styles.cardValue}>
            {!filtroTipo || ["publicidad", "BTL"].includes(filtroTipo)
              ? `${displayMoneda} ${(totales.totalNeto || 0).toLocaleString(
                getLocale(pais),
                { maximumFractionDigits: displayDecimales, minimumFractionDigits: displayDecimales }
              )}`
              : "-"}
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.cardLabel}>COBRADO</div>
          <div className={styles.cardValue}>
            {`${displayMoneda} ${(totales.totalCobrado || 0).toLocaleString(getLocale(pais), {
              maximumFractionDigits: displayDecimales,
              minimumFractionDigits: displayDecimales,
            })}`}
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.cardLabel}>PENDIENTE DE COBRO</div>
          <div className={styles.cardValue}>
            {`${displayMoneda} ${((totales.totalVenta || 0) - (totales.totalCobrado || 0)).toLocaleString(getLocale(pais), {
              maximumFractionDigits: displayDecimales,
              minimumFractionDigits: displayDecimales,
            })}`}
          </div>
        </div>
      </div>

      {/* Tabla condicional según tipo filtrado */}
      {tabActivo === "ventas" && (() => {
        if (!filtroTipo) return renderTableSummary();
        if (filtroTipo === "publicidad") return renderTablePublicidad();
        if (filtroTipo === "BTL") return renderTablePublicidad();
        if (filtroTipo === "hardware") return renderTableHardware();
        if (filtroTipo === "Gestión") return renderTableGestion();
        return renderTableSummary();
      })()}
      {/* Modal para editar factura */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Factura</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          {warnSinEdificios && (
            <div className="alert alert-warning" style={{ fontSize: "0.85rem", marginBottom: "12px", paddingBottom: "8px" }}>
              <div>Esta factura no tiene edificios asignados. Podrás asignarlos posteriormente.</div>
              <Form.Check
                type="checkbox"
                id="registrarComoCredito"
                label="Registrar monto como crédito a favor del cliente"
                checked={registrarComoCredito}
                onChange={(e) => setRegistrarComoCredito(e.target.checked)}
                style={{ marginTop: "8px", fontSize: "0.85rem" }}
                disabled={loading}
              />
            </div>
          )}
          {oportunidadEditada
            && (oportunidadEditada.type === "HW-OPEX" || oportunidadEditada.type === "Gestión")
            && (
              <div
                style={{
                  background: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  padding: "10px 14px",
                  marginBottom: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <span style={{ fontSize: "0.75rem", color: "#6c757d", display: "block" }}>Valor Cuota</span>
                  <span style={{ fontSize: "0.95rem", fontWeight: 600 }}>
                    {oportunidadEditada.valor_cuota != null
                      ? `${Number(oportunidadEditada.valor_cuota).toLocaleString("es-CL", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })} ${oportunidadEditada.moneda_cuota === "UF" ? "UF" : "US$"}`
                      : "—"}
                  </span>
                </div>
                <div style={{ textAlign: "right" }}>
                  <span style={{ fontSize: "0.75rem", color: "#6c757d", display: "block" }}>Periodo</span>
                  <span style={{ fontSize: "0.95rem", fontWeight: 600 }}>
                    {oportunidadEditada.label_extra || "—"}
                  </span>
                </div>
              </div>
            )}
          <Form>
            <Form.Group className="mb-3" controlId="formNumeroFactura">
              <Form.Label>Número de Factura *</Form.Label>
              <Form.Control
                type="text"
                name="facturanumero"
                value={formData.facturanumero}
                onChange={handleInputChange}
                placeholder="Ingrese el número de factura"
                disabled={loading}
                required
                style={
                  formData.facturafecha && !formData.facturanumero
                    ? { borderColor: "#dc3545", boxShadow: "0 0 0 0.2rem rgba(220,53,69,.25)" }
                    : {}
                }
              />
              {formData.facturafecha && !formData.facturanumero && (
                <Form.Text style={{ color: "#dc3545", fontSize: "0.75rem" }}>
                  Falta número de factura
                </Form.Text>
              )}
              {otrasConMismaFactura.length > 0 && (
                <div
                  style={{
                    marginTop: "6px",
                    padding: "8px 10px",
                    backgroundColor: "#e8f4fd",
                    border: "1px solid #b6d4fe",
                    borderRadius: "4px",
                    fontSize: "0.78rem",
                    color: "#0a58ca",
                  }}
                >
                  <strong>Factura compartida con:</strong>
                  {otrasConMismaFactura.map((op) => (
                    <div key={op.id} style={{ marginTop: "2px" }}>
                      {op.cliente?.toUpperCase() || "—"} — {op.type}
                      {op.label_extra ? ` (${op.label_extra})` : ""}
                    </div>
                  ))}
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formFechaFactura">
              <Form.Label>Fecha de Factura *</Form.Label>
              <Form.Control
                type="date"
                name="facturafecha"
                value={formData.facturafecha}
                onChange={handleInputChange}
                disabled={loading}
                min="2023-01-01"
                max="2050-12-31"
                required
              />
            </Form.Group>

            {/* NUEVO CAMPO */}
            <Form.Group className="mb-3" controlId="formPlazoCobro">
              <Form.Label>Fecha de Cobro Proyectada *</Form.Label>
              <Form.Control
                type="date"
                name="plazocobro"
                value={formData.plazocobro}
                onChange={handleInputChange}
                disabled={loading}
                min={formData.facturafecha || undefined}
                required
              />
            </Form.Group>

            {/* Fecha de Cobro Real — solo lectura (se registra al vincular el movimiento bancario) */}
            <Form.Group className="mb-3" controlId="formFechaCobroReal">
              <Form.Label>Fecha de Cobro Real</Form.Label>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <Form.Control
                  type="date"
                  name="facturafechacobro"
                  value={formData.facturafechacobro || ""}
                  disabled
                  readOnly
                />
                {facturaSIIVinculada && (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    style={{ whiteSpace: "nowrap", fontSize: "0.75rem" }}
                    onClick={() => setPlanCuotasModal({
                      factura: facturaSIIVinculada,
                      tipo: "cobro",
                    })}
                  >
                    En cuotas
                  </button>
                )}
              </div>
              <Form.Text style={{ fontSize: "0.72rem", color: "#6c757d" }}>
                Se registra automáticamente al vincular el movimiento bancario.
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {[ROLES.GERENCIA, ROLES.ADMINISTRATIVO].includes(rol) && oportunidadEditada?.facturanumero && (
            <Button variant="outline-danger" onClick={handleClearFactura} disabled={loading} className="me-auto">
              Limpiar factura
            </Button>
          )}
          <Button variant="secondary" onClick={handleCloseModal} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveChanges} disabled={loading}>
            {loading ? "Guardando..." : "Guardar Cambios"}
          </Button>
        </Modal.Footer>
      </Modal>
      <SeleccionarDTEModal
        isOpen={!!siiModalOportunidad}
        toggle={() => setSiiModalOportunidad(null)}
        oportunidad={siiModalOportunidad}
        onVinculada={handleVinculada}
      />
      {cobroPickerOp && (
        <div
          style={{
            position: "fixed",
            top: Math.min(cobroPickerOp._pickerTop || 200, window.innerHeight - 320),
            right: Math.max(cobroPickerOp._pickerRight || 50, 20),
            zIndex: 9999,
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            borderRadius: 8,
            background: "#fff",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <DatePicker
            selected={cobroPickerOp.plazocobro ? new Date(cobroPickerOp.plazocobro + "T12:00:00") : null}
            onChange={(date) => guardarPlazoCobro(cobroPickerOp, date)}
            onClickOutside={() => setCobroPickerOp(null)}
            inline
          />
        </div>
      )}
      {planCuotasModal && (
        <PlanCuotasModal
          isOpen={!!planCuotasModal}
          onClose={() => setPlanCuotasModal(null)}
          tipo={planCuotasModal.tipo}
          factura={planCuotasModal.factura}
          onSuccess={() => setPlanCuotasModal(null)}
        />
      )}
    </div>
  );
};